import React from "react";
import Header from "./components/Headerpicking";
import Sidebar from "./components/Sidebar";
import MainContent from "./components/MainContent";

const UserDashboard = () => {
    return (
        <div className="flex flex-col h-screen bg-gray-100">
            <Header />
            <div className="flex flex-grow p-6">
                <Sidebar />
                <MainContent />
            </div>
        </div>
    );
};

export default UserDashboard;
